import CandidateProfileDocuments from './CandidateProfileDocuments.component';

export default CandidateProfileDocuments;